export { default } from "@vaporfi/next-image-loader";
